import {InjectionToken} from '@angular/core';
import {DistanceUnit} from '../domain/utils/distanceUnit';

export const DISTANCE_UNIT = new InjectionToken<string>('How to display distance', {factory: () => DistanceUnit.KM});
